import moment from "moment";
import { memo, useCallback, useEffect, useState } from "react"
import jalaali from "jalaali-js";
import { tools } from "../../../core/utils/tools";
import { TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { Button, Card, Col, Modal, Row, Spinner } from "react-bootstrap";
import SelectComponent from "../_Components/ReactSelectComponent";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { PatternFormat } from "react-number-format";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAccount from "../../../core/api/api.account";
import { isEmpty } from "lodash";
import Swal from "sweetalert2";
import ApiUserWithdrawal from "../../../core/api/api.userWithdrawal";
import SwalMessage from "../_Components/SwalMessage";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // استایل پیش‌فرض

const DoneStatusModal = ({ setShowDoneModal, showDoneModal, setSelectedCheckBoxes }) => {
  const [accountSaamaneh, setAccountSaamaneh] = useState([]);
  const methods = useForm({ defaultValues: { paymentDate: tools.toJalaali(new Date()), paymentTime: moment().format("HH:mm") } })
  const handleClose = useCallback(() => { setShowDoneModal([]) }, [])

  const onSubmit = useCallback(async (data) => {

    try {
      if (data.status == "انجام_شد" && showDoneModal.find(item => item.isNewDestinationAccount)) {
        Swal.fire({
          title: "تایید نهایی درخواست برداشت وجه",
          text: "برخی از حساب ها جدید هستند و تاکنون برایشان هیچ درخواست برداشت وجهی تایید نشده است، آیا از تایید نهایی درخواست برداشت وجه مطمن هستید؟",
          icon: "question",
          showDenyButton: true,
          confirmButtonText: "بله",
          denyButtonText: "خیر",
          customClass: {
            actions: "my-actions",
            confirmButton: "order-2 btn btn-success px-5",
            denyButton: "order-3 btn btn-danger px-5",
          },
          focusCancel: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            const resdata = await ApiUserWithdrawal.updateUserWithdrawalStatusInGrouping({
              status: 3,
              paymentTime: data.paymentTime,
              paymentDate: data.paymentDate,
              statusDesc: data.statusDesc,
              sourceAccountId: data.sourceAccountId?.value,
              trackingCode: data.trackingCode,
              userWithdrawalIds: showDoneModal.map(item => item.id)
            })
            if (resdata.succeeded) {
              SwalMessage({
                title: "تغییرات این آیتم ها با موفقیت ثبت شد",
                iSsuccess: true,
              });
              setSelectedCheckBoxes([])
              handleClose()
              const submitButton = document.getElementById("submitButton")
              submitButton?.click()
            } else
              SwalMessage({
                title: resdata.message,
                iSsuccess: false,
              });
          }
        });
        return
      }
      const resdata = await ApiUserWithdrawal.updateUserWithdrawalStatusInGrouping({
        status: 3,
        paymentTime: data.paymentTime,
        paymentDate: data.paymentDate,
        statusDesc: data.statusDesc,
        sourceAccountId: data.sourceAccountId?.value,
        trackingCode: data.trackingCode,
        userWithdrawalIds: showDoneModal.map(item => item.id)
      })
      if (resdata.succeeded) {
        SwalMessage({
          title: "تغییرات این آیتم با موفقیت ثبت شد",
          iSsuccess: true,
        });
        setSelectedCheckBoxes([])
        handleClose()
        const submitButton = document.getElementById("submitButton")
        submitButton?.click()
      } else
        SwalMessage({
          title: resdata.message,
          iSsuccess: false,
        });
    } catch { }
  })

  useEffect(() => {
    (async () => {
      const allAccountSaAmaneh = await ApiAccount.getAllAccountSaamaneh({ pageSize: 1, pageNumber: 20 });
      if (!isEmpty(allAccountSaAmaneh) && allAccountSaAmaneh.succeeded) {
        setAccountSaamaneh(allAccountSaAmaneh.data);
        methods.setValue("saamanehtype", 0);
      }
    })()
  }, [])

  return (
    <Modal centered size="md" onHide={handleClose} show={setShowDoneModal}>
      <form id="form2" onSubmit={methods.handleSubmit(onSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>تغییر وضعیت</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            showDoneModal.map((item, index) => <Tippy
              content={!(item.status == 4 || item.status == 3 || item.walletUseAvailableAmount - item.rialAmount >= 0) ? "برای این حساب هیچ درخواست برداشت وجهی تایید نشده!" : "مبلغ درخواست داده شده توسط کاربر از موجودی کیف پولش بیشتری است!"}
              placement="top"
              hideOnClick={false}
              key={index}
              disabled={(item.status == 4 || item.status == 3 || item.walletUseAvailableAmount - item.rialAmount >= 0) || !item.isNewDestinationAccount}
            >
              <Row className="mt-5" >
                <Col xs="12">
                  <Card
                    style={{
                      borderColor: item.status != 4 && item.status != 3 && item.walletUseAvailableAmount - item.rialAmount < 0 ? "rgba(255,0,0,0.5)" : item.isNewDestinationAccount ? "rgb(255,168,0)" : "",
                      backgroundColor: item.status != 4 && item.status != 3 && item.walletUseAvailableAmount - item.rialAmount < 0 ? "rgba(255,0,0,0.02)" : item.isNewDestinationAccount ? "rgba(255,168,0,0.05)" : ""
                    }}
                  >
                    <Card.Body className="px-7 py-3 ">
                      <Row className="border-bottom p-3">
                        <Col className="p-0" style={{ fontSize: 11, maxWidth: "fit-content" }}>
                          <div className="fw-bold">شناسه</div>
                          <div>{item.id}</div>
                        </Col>
                        <Col className="p-0 text-center flex-grow-1" style={{ fontSize: 11 }}>
                          <div className="fw-bold">مبلغ</div>
                          <div>{tools.formatPriceNumber(item.rialAmount)}</div>
                        </Col>
                        <Col className="p-0 text-center flex-grow-1" style={{ fontSize: 11 }}>
                          <div className="fw-bold">نوع حساب</div>
                          <div>{item.userType}</div>
                        </Col>
                        <Col className="p-0 text-center flex-grow-1" style={{ fontSize: 11 }}>
                          <div className="fw-bold">نام و نام خانوادگی</div>
                          <div>{item.userFullName}</div>
                        </Col>
                      </Row>
                      <Row className="p-3">
                        <Col xs="3" className="p-0" style={{ fontSize: 11, maxWidth: "fit-content" }}>
                          <div className="fw-bold">نام بانک</div>
                          <div>{item.accountBank}</div>
                        </Col>
                        <Col className="p-0 text-center flex-grow-1" style={{ fontSize: 11 }}>
                          <div className="fw-bold">صاحب حساب</div>
                          <div>{item.accountCardOwnerName}</div>
                        </Col>
                        <Col className="p-0 text-center flex-grow-1" style={{ fontSize: 11 }}>
                          <div className="fw-bold">شماره حساب</div>
                          <div>{item.accountNumber}</div>
                        </Col>
                        <Col className="p-0 text-center flex-grow-1" style={{ fontSize: 11 }}>
                          <div className="fw-bold">شماره کارت</div>
                          <div>{item.accountCardNumber}</div>
                        </Col>
                        <Col xs="12" className="p-0 mt-2" style={{ fontSize: 11 }}>
                          <div className="fw-bold">شماره شبا</div>
                          <div>{item.accountShebaNumber}</div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Tippy>)}
          <Row>
            <Col xs="12">
              <Controller
                name="sourceAccountId"
                control={methods.control}
                render={({ field }) => (
                  <SelectComponent
                    className="mt-5 w-20"
                    variant="outlined"
                    size="small"
                    margin="normal"
                    placeholder="انتخاب حساب داخلی"
                    options={accountSaamaneh?.map((item) => ({
                      value: item.id,
                      label: item.accountOwnerName + "-- " + item.bank + "-- " + item.accountNumber,
                    }))}
                    field={field}
                    noClear
                  />
                )}
              />
              {methods.formState.errors.sourceAccountId && <span> لطفا یکی از حساب های داخلی را انتخاب نمایید </span>}
            </Col>
          </Row>
          <Row className="mt-5">
            <Col xs="6">
              <Controller
                name="paymentDate"
                control={methods.control}
                render={({ field: { onChange, value } }) => (
                  <ShamsiDatePicker value={value} onChange={(e) => { onChange(tools.DateFormat(e)) }} label="" placeholder="تاریخ پرداخت" />
                )}
              />
            </Col>
            <Col xs="6">
              <Controller
                name="paymentTime"
                control={methods.control}
                rules={{ required: methods.watch("status")?.value == "انجام شد" }}
                render={({ field: { onChange, value } }) => (
                  <PatternFormat
                    format="##:##"
                    mask=""
                    customInput={TextField}
                    label="زمان پرداخت"
                    type="search"
                    onKeyDown={(e) => {
                      if (e.key === "Escape") {
                        e.stopPropagation()
                      }
                    }}
                    variant="outlined"
                    margin="normal"
                    className="mt-0"
                    size="small"
                    value={value || ""}
                    onChange={onChange}
                  />
                )}
              />
              {methods.formState.errors.paymentTime && <span>زمان پرداخت نمیتواند خالی باشد</span>}
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Controller
                name="trackingCode"
                control={methods.control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="کد پیگیری"
                    type="text"
                    className=""
                    variant="outlined"
                    size="small"
                    margin="normal"
                    value={value || ""}
                    onInput={onChange}
                  />
                )}
              />
              {methods.formState.errors.trackingCode && <span>کد پیگیری درست وارد نشده است</span>}
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Controller
                name="statusDesc"
                control={methods.control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="توضیحات"
                    type="text"
                    rows={3}
                    multiline
                    variant="outlined"
                    margin="normal"
                    className=""
                    // placeholder="توضیحات"
                    value={value || ""}
                    onInput={onChange}
                    sx={{
                      ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                        padding: "8.5px 14px 8.5px 0px !important",
                      }
                    }}
                  />
                )}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" type="submit" disabled={methods.formState.isSubmitting}>
            {methods.formState.isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
            <SaveIcon /> ذخیره
        </Button>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
        </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}

export default memo(DoneStatusModal)